import { render } from "./AddProperty.vue?vue&type=template&id=43187658&ts=true"
import script from "./AddProperty.vue?vue&type=script&lang=ts"
export * from "./AddProperty.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__